var BlockCompiler = require("../../compiler/compiler.js");
var CBlockType = require("../../compiler/types.js");
var CoreFunctions = require("../../compiler/corefunc.js");

BlockCompiler.defineBlock("control_isclone", {
  type: CBlockType.OUTPUT,
  func: function (utils) {
    return `sprite.isClone`;
  },
});
